import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Action, Project } from "../projectSlice";
import { Alert, Box, Button, ButtonGroup, Dialog, Divider, Grid, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Paper, Skeleton, Stack, Tab, Typography } from "@mui/material";
import { Localized, useLocalization } from "@fluent/react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useCallback, useEffect, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React from "react";
import { BottomAppBar } from "../../../app/BottomAppBar";
import { LoadProjects } from "../../../app/AppDataLoader";
import { EditDescriptionField, EditDescriptionFieldProps } from "../EditDescriptionField";
import { If } from "../../../app/If";
import { EditSimpleDescriptionField, EditSimpleDescriptionFieldProps } from "../EditSimpleDescriptionField";
import { loadManyBlobs } from "../../documents/attachementsSlice";
import { APIError, AppId } from "../../../app/appTypes";
import { unwrapResult } from "@reduxjs/toolkit";
import produce from "immer";
import { NotesList } from "../Notes/NotesList";
import { selectLoggedUser } from "../../user/userSlice";
import { MeetingMinutesList } from "../mettingMinutes/MeetingMinutesList";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ActionRunner } from "../ActionRunner";
import DeleteIcon from '@mui/icons-material/Delete';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import DoneIcon from '@mui/icons-material/Done';
import { BusinessCaseListForProject } from "../../businessCase/BusinessCaseListForProject";
import { selectSettings } from "../../settings/settingsSlice";
import { enUS, plPL } from "@mui/x-data-grid/locales";
import { ErrorContainer } from "../../../app/ErrorContainer";
import { LoadingContainer } from "../../../app/LoadingContainer";
import { ProjectHeader } from "../Components/ProjectHeader";
import { ProjectSectionHeader } from "../Components/ProjectSectionHeader";
import { Description } from "@mui/icons-material";
import { ProjectKeyValueRow } from "../Components/ProjectKeyValueRow";
import CancelIcon from '@mui/icons-material/Cancel';
import ArchiveIcon from '@mui/icons-material/Archive';
import { ArchiveProjectDialog } from "../Dialogs/ArchiveProjectDialog";
import { loadValidationProject } from "./validationProjectSlice";
import { ValidationProjectTeamTab } from "./tabs/ValidationProjectTeamTab";
import { ProjectComputerizedSystemsTab } from "./tabs/ProjectComputerizedSystemsTab";
import { ProjectDocumentsTab } from "./tabs/ProjectDocumentsTab";
import { ProjectDevicesTab } from "./tabs/ProjectDevicesTab";
import { ProjectProcessesTab } from "./tabs/ProjectProcessesTab";
import { EntityBreadcrumbs } from "../../../app/components/EntityBreadcrumbs";


type FormTabs = "documents" | "process" | "management" | "team" | "attachments" | "devices" | "computerizedSystems" | "conversations" | "meetingMinutes" | "businessCases"


export const ValidationProjectForm = () => {
    const { id: paramId } = useParams(); const id = paramId ?? ''
    return <>
        {/* *To potzrebne jeszcze ? */}
        <LoadProjects component={<Skeleton />}>
            <LoadValidationProjectDetails projectId={id} />
        </LoadProjects>
    </>
}

export const LoadValidationProjectDetails = ({ projectId }: { projectId: AppId }) => {
    const dispatch = useAppDispatch()
    const [project, setProject] = useState<Project | undefined>(undefined)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [loadingError, setLoadingError] = useState<APIError | undefined>(undefined)
    const [loadingErrorOccured, setLoadingErrorOccured] = useState<boolean>(false)

    useEffect(() => {
        setIsLoading(true);
        dispatch(loadValidationProject(projectId))
            .then(unwrapResult)
            .then(project => setProject(project))
            .catch((error) => { console.log(error); setLoadingErrorOccured(true); setLoadingError(error); })
            .finally(() => setIsLoading(false));
    }, [dispatch, projectId])

    if (loadingErrorOccured) {
        return <>
            <ErrorContainer error={loadingError} />
        </>
    }

    if (isLoading) {
        return <LoadingContainer />
    }

    //!

    if (project === undefined) return <Skeleton variant='rectangular' sx={{ minHeight: '400px' }} />

    return <EditForm project={project} setProject={setProject} />
}

type DialogState
    = { tag: 'none' }
    | { tag: 'editField', props: EditDescriptionFieldProps }
    | { tag: 'editSimpleField', props: EditSimpleDescriptionFieldProps }


interface EditFormProps {
    project: Project
    setProject: React.Dispatch<React.SetStateAction<Project | undefined>>
}
const EditForm = (props: EditFormProps) => {
    const { project, setProject } = props
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { l10n } = useLocalization()

    const [actionToRun, setActionToRun] = useState<Action & { name: string, description: string } | null>(null)
    const [archiveDialogVisible, setArchiveDialogVisible] = useState(false)

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [openMenu, setOpenMenu] = useState(null);

    const [params, setParams] = useSearchParams()
    const tab = params.get('tab') as FormTabs || 'devices'
    const setTab = (tab: FormTabs) => {
        params.set('tab', tab)
        setParams(params, { replace: true })
    }

    const [dialog, setDialog] = useState<DialogState>({ tag: 'none' })

    const createdDate = project?.createDate ? new Date(project.createDate).toISOString().split('T')[0] : "";

    const isProjectFinished = project?.status === "F";
    const isProjectCanceled = project?.status === "C";
    const isProjectPaused = project?.status === "H";

    const onArchiveSuccess = useCallback((id: AppId) => {

        setArchiveDialogVisible(false)
        navigate("/projects")
    }, [dispatch])

    const handleTabChange = useCallback((_, newTab) => {
        setTab(newTab)
    }, [])

    const handleBackButtonClick = useCallback(() => {
        navigate(-1)
    }, [navigate])

    const handleEditDescriptionClick = useCallback(() => {
        if (project) {
            setDialog({
                tag: 'editField',
                props: {
                    projectId: project.id,
                    field: 'description',
                    value: project.description,
                    onSave: (ph) => {
                        setDialog({ tag: 'none' })
                        setProject(produce(draft => {
                            if (draft) {
                                draft.description = ph.description
                            }
                        }))
                    },
                    onCancel: () => setDialog({ tag: 'none' })
                }
            })
        }
    }, [project])
    const handleEditSimpleDescriptionClick = (fieldName: string) => {
        if (project) {
            setDialog({
                tag: 'editSimpleField',
                props: {
                    projectId: project.id,
                    field: fieldName,
                    value: project[`${fieldName}`] || '',
                    onSave: (ph) => {
                        setDialog({ tag: 'none' })
                        setProject(produce(draft => {
                            if (draft) {
                                draft[`${fieldName}`] = ph[`${fieldName}`]
                            }
                        }))
                    },
                    onCancel: () => setDialog({ tag: 'none' })
                }
            })
        }
    }

    useEffect(() => {
        if (project) {
            dispatch(loadManyBlobs([project.guid]))
        }
    }, [])

    if (project === undefined) return <Alert severity="error">Project not found</Alert>

    return <>
        <Paper elevation={0} sx={{ p: 0 }}>
            <EntityBreadcrumbs current={{ type: "project", id: project.id }} />
            <ProjectHeader project={project} />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TabContext value={tab}>
                        <TabList onChange={handleTabChange}>
                            <Tab
                                key={1}
                                value={"devices"}
                                label={<Localized id="devices">Urządzenia</Localized>} />
                            <Tab
                                key={2}
                                value={"computerizedSystems"}
                                label={<Localized id="menu-computerized-systems">Systemy skomputeryzowane</Localized>} />
                            <Tab
                                key={3}
                                value={"process"}
                                label={<Localized id="project-process-list">Lista procesów</Localized>} />
                            <Tab
                                key={4}
                                value={"documents"}
                                label={<Localized id="project-documents">Dokumenty</Localized>} />


                            <Tab
                                key={5}
                                value={"management"}
                                label={<Localized id="project-management">Zarządzanie</Localized>} />
                            <Tab
                                key={6}
                                value={"team"}
                                label={<Localized id="project-team">Zespół</Localized>} />
                            <Tab
                                key={7}
                                value={"meetingMinutes"}
                                label={<Localized id="meeting-minutes-minute-list">Lista Notatek</Localized>} />
                            <Tab
                                key={8}
                                value={"notes"}
                                label={<Localized id="project-notes">notes</Localized>} />

                        </TabList>
                        <TabPanel value="devices">
                            <ProjectDevicesTab projectId={project.id} />
                        </TabPanel>
                        <TabPanel value="documents">
                            <ProjectDocumentsTab projectId={project.id} />
                        </TabPanel>
                        <TabPanel value="process">
                            <ProjectProcessesTab projectId={project.id} />
                        </TabPanel>

                        <TabPanel value="computerizedSystems">
                            <ProjectComputerizedSystemsTab projectId={project.id} />
                        </TabPanel>
                        <TabPanel value="team">
                            <ValidationProjectTeamTab
                                projectId={project.id}
                            />
                        </TabPanel>
                        <TabPanel value="meetingMinutes">
                            <MeetingMinutesList
                                objectId={project.guid}
                                objectType='PROJECT'
                                canEdit={true}
                            />
                        </TabPanel>
                        <TabPanel value="notes">
                            <NotesList
                                objectId={project.guid}
                                canEdit={true}
                            />
                        </TabPanel>
                        <TabPanel value="management">
                            <Grid container spacing={1}>
                                <If condition={true}>
                                    <Grid item xs={12}>
                                        <Paper variant="outlined" sx={{ p: 1, mb: 2 }}>
                                            <ProjectSectionHeader
                                                icon={<Description fontSize="small" />}
                                                title={<Localized id="project-management">
                                                    _management
                                                </Localized>}
                                            />
                                            <Divider sx={{ mb: 1.5 }} />
                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                flexWrap="wrap"
                                                alignItems="center"
                                            >
                                                {!isProjectCanceled && (
                                                    <>
                                                        {project?.status !== "I" && (
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                color="secondary"
                                                                startIcon={<PlayArrowIcon fontSize="small" />}
                                                                onClick={() =>
                                                                    setActionToRun({
                                                                        id: project?.id,
                                                                        status: "I",
                                                                        type: "PUT",
                                                                        authorize: false,
                                                                        actionId: "startProject",
                                                                        name: "",
                                                                        description: "",
                                                                    })
                                                                }
                                                            >
                                                                <Localized id="project-start">
                                                                    Rozpocznij
                                                                </Localized>
                                                            </Button>
                                                        )}

                                                        {!isProjectPaused && (
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                color="warning"
                                                                startIcon={<PauseIcon fontSize="small" />}
                                                                onClick={() =>
                                                                    setActionToRun({
                                                                        id: project?.id,
                                                                        status: "H",
                                                                        type: "PUT",
                                                                        authorize: false,
                                                                        actionId: "pauseProject",
                                                                        name: "",
                                                                        description: "",
                                                                    })
                                                                }
                                                            >
                                                                <Localized id="project-pause">
                                                                    Wstrzymaj
                                                                </Localized>
                                                            </Button>
                                                        )}

                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            color="error"
                                                            startIcon={<CancelIcon fontSize="small" />}
                                                            onClick={() =>
                                                                setActionToRun({
                                                                    id: project?.id,
                                                                    status: "C",
                                                                    type: "PUT",
                                                                    authorize: true,
                                                                    actionId: "cancelProject",
                                                                    name: "",
                                                                    description: "",
                                                                })
                                                            }
                                                        >
                                                            <Localized id="project-cancel">
                                                                Anuluj
                                                            </Localized>
                                                        </Button>

                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            color="secondary"
                                                            startIcon={<DoneIcon fontSize="small" />}
                                                            onClick={() =>
                                                                setActionToRun({
                                                                    id: project?.id,
                                                                    status: "F",
                                                                    type: "PUT",
                                                                    authorize: true,
                                                                    actionId: "finishProject",
                                                                    name: "",
                                                                    description: "",
                                                                })
                                                            }
                                                        >
                                                            <Localized id="project-finish">
                                                                Zakończ
                                                            </Localized>
                                                        </Button>

                                                    </>
                                                )}

                                                <Box sx={{ flexGrow: 1 }} />
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    color="secondary"
                                                    startIcon={<ArchiveIcon fontSize="small" />}
                                                    onClick={() =>
                                                        setArchiveDialogVisible(true)
                                                    }
                                                >
                                                    <Localized id="archive">
                                                        _Archiwizuj
                                                    </Localized>
                                                </Button>
                                                <Button
                                                    size="small"
                                                    color="error"
                                                    variant="outlined"
                                                    startIcon={<DeleteIcon fontSize="small" />}
                                                    onClick={() =>
                                                        setActionToRun({
                                                            id: project?.id,
                                                            type: "POST",
                                                            authorize: true,
                                                            actionId: "deleteProject",
                                                            name: "",
                                                            description: "",
                                                        })
                                                    }
                                                >
                                                    <Localized id="delete">
                                                        Usuń
                                                    </Localized>
                                                </Button>
                                            </Stack>
                                        </Paper>
                                    </Grid>
                                </If>
                                <Grid item xs={12}>
                                    <Paper variant="outlined" sx={{ p: 1, mb: 2 }}>
                                        <ProjectSectionHeader
                                            icon={<Description fontSize="small" />}
                                            title={<Localized id="project-basic-data">_Dane projektu</Localized>}
                                        />
                                        <Divider sx={{ mb: 1.5 }} />
                                        {/* Numer projektu */}
                                        <ProjectKeyValueRow
                                            label={l10n.getString("project-no", null, "_No")}
                                            value={project.no}
                                            showEdit={true}
                                            onEdit={() => handleEditSimpleDescriptionClick("no")}
                                        />

                                        {/* Tytuł projektu */}
                                        <ProjectKeyValueRow
                                            label={l10n.getString("project-title", null, "_Title")}
                                            value={project.name}
                                            showEdit={true}
                                            onEdit={() => handleEditSimpleDescriptionClick("name")}
                                        />

                                        {/* General contractor */}
                                        <ProjectKeyValueRow
                                            label={l10n.getString("project-general-contractor", null, "_GeneralContractor")}
                                            value={project.generalContractor || ""}
                                            showEdit={true}
                                            onEdit={() => handleEditSimpleDescriptionClick("generalContractor")}
                                        />

                                        {/* Investor */}
                                        <ProjectKeyValueRow
                                            label={l10n.getString("project-investor", null, "_Investor")}
                                            value={project.investor || ""}
                                            showEdit={true}
                                            onEdit={() => handleEditSimpleDescriptionClick("investor")}
                                        />

                                        {/* Opis (HTML) */}
                                        <ProjectKeyValueRow
                                            label={l10n.getString("project-description", null, "_Description")}
                                            value={
                                                <Typography variant="body1"
                                                    fontWeight={600} sx={{ ml: 1 }}>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: project.description ?? "",
                                                        }}
                                                    />
                                                </Typography>
                                            }
                                            showEdit={true}
                                            onEdit={handleEditDescriptionClick}
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                        </TabPanel>
                    </TabContext>
                </Grid>
            </Grid>
            <BottomAppBar>
                <Button key="back" onClick={handleBackButtonClick} color="secondary" variant="outlined">
                    <Localized id="back">Wróć</Localized>
                </Button>
            </BottomAppBar>
        </Paper>
        {archiveDialogVisible && project.id &&
            <ArchiveProjectDialog id={project.id}
                onSuccess={onArchiveSuccess}
                onCancel={() => setArchiveDialogVisible(false)} />
        }
        <>{actionToRun && <ActionRunner
            action={actionToRun}
            onError={() => { }}
            onSuccess={result => {
                setActionToRun(null)
                if (result.actionId === "startProject" || result.actionId === "pauseProject" || result.actionId === "cancelProject" || result.actionId === "finishProject") {
                    setProject(produce(draft => {
                        if (draft) {
                            draft.status = result.status;
                        }
                    }))
                } else if (result.actionId === "startProjectProcess" || result.actionId === "pauseProjectProcess" || result.actionId === "finishProjectProcess") {
                    setProject(produce(draft => {
                        if (draft) {
                            let x = draft.process.find(f => f.id === result.id);
                            if (x) x.status = result.status;
                        }
                    }))
                } else if (result.actionId === "deleteProjectProcess") {
                    setProject(produce(draft => {
                        if (draft) {
                            let x = draft.process.findIndex(f => f.id === result.id);
                            if (x !== -1) draft.process.splice(x, 1);
                        }
                    }))
                }
            }}
            onCancel={() => setActionToRun(null)} />}</>
        <DialogDispatcher dialog={dialog} />
    </>
}

const DialogDispatcher = ({ dialog }: { dialog: DialogState }) => {
    switch (dialog.tag) {
        case 'none':
            return null

        case 'editField':
            return <EditDescriptionField {...dialog.props} />

        case 'editSimpleField':
            return <EditSimpleDescriptionField {...dialog.props} />

    }
}

